import React from 'react';
import LocationTemplate from './LocationTemplate';

const PinetopsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Pinetops"
      stateName="North Carolina"
      countyName="Edgecombe"
      zipCodes={["27864"]}
      latitude={35.7893}
      longitude={-77.6375}
      population={1374}
      historicalFact="Named for the large pine trees that once dominated the area landscape."
      nearbyTowns={[
        "Tarboro, NC",
        "Rocky Mount, NC",
        "Macclesfield, NC",
        "Elm City, NC",
        "Sharpsburg, NC",
        "Nashville, NC",
        "Wilson, NC",
        "Battleboro, NC"
      ]}
    />
  );
};

export default PinetopsPage;